import type { IData } from '../model/IData'
import type { IPerson } from '../model/IPerson'
import { getDeathDateFallback } from './getDeathDateFallback'

export function isDead(data: IData, person: IPerson) {
	const deathDate = getDeathDateFallback(data, person)
	return !!deathDate.value
}
